export default __webpack_public_path__ + "static/media/package-img4.b0c4c69e.jpg";